export const OPTHINES = {
  voteName: '2019poject/2019cqzyzfw',
  themeColor: {
    activeBgColor: '#e43524',
    inactiveBgColor: '#ffffff',
  },
  placeholder: '搜索姓名/编号',
  tabs: [
    {
      tabName: '首页',
      tabPath: '/2019AdvancerVolunteerSelection/HomeIndex',
    },
    {
      tabName: '活动展示',
      tabPath: '/2019AdvancerVolunteerSelection/Activities',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019AdvancerVolunteerSelection/RelativeNews',
    },
    {
      tabName: '评选说明',
      tabPath: '/2019AdvancerVolunteerSelection/SelectRules',
    },
  ],
  tabs1: [
    {
      tabName: '首页',
      tabPath: '/2019AdvancerVolunteerSelection/HomeIndex',
    },
    {
      tabName: '评选说明',
      tabPath: '/2019AdvancerVolunteerSelection/HomeIndexSelectRules',
    },
  ],
  mustSearch: 'Button',
  buttonBg: 'rgb(249,15,3)',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
};
